import { SUPPORTED_IMAGE_TYPES, createPdfFromImages } from "../pdf/createPdfFromImages"

/**
 * CHM (and other sharing orgs) reject raw image uploads for itemized bills, so
 * bills downloaded for portal submission must be PDFs. If the downloaded file is
 * a supported image type (JPEG/PNG) this converts it to a single-page PDF and
 * swaps the extension to .pdf; otherwise it returns the data unchanged.
 */
export async function convertImageBlobToPdf(
  data: Blob,
  blob: { file_name: string; content_type: string },
): Promise<{ data: Blob; fileName: string }> {
  if (!SUPPORTED_IMAGE_TYPES.includes(blob.content_type)) {
    return { data, fileName: blob.file_name }
  }

  const file = new File([data], blob.file_name, { type: blob.content_type })
  const pdfData = await createPdfFromImages([file])
  return { data: pdfData, fileName: downloadFileNameForBlob(blob) }
}

/**
 * Returns the file name a blob will have once downloaded with
 * convertImagesToPdf enabled — i.e. the same name convertImageBlobToPdf
 * produces. Use this to display the eventual download name so the UI matches
 * what the user actually receives.
 */
export function downloadFileNameForBlob(blob: { file_name: string; content_type: string }): string {
  return SUPPORTED_IMAGE_TYPES.includes(blob.content_type)
    ? replaceExtensionWithPdf(blob.file_name)
    : blob.file_name
}

function replaceExtensionWithPdf(fileName: string): string {
  const dot = fileName.lastIndexOf('.')
  const base = dot > 0 ? fileName.slice(0, dot) : fileName
  return `${base}.pdf`
}
